module.exports = __webpack_public_path__ + "img/36.6c0b737.webp";